import React from 'react';
import PropTypes from 'prop-types';
import './Row.css';

function Row({ columns, rowClass = '', cellClass = '', cellClass2='', cellClass2ConditionList=[], columnWidths, idViewing, idArrayId, onClick }) {
  const filteredColumnWidths = idViewing
    ? columnWidths 
    : columnWidths.filter((_, index) => index !== idArrayId);
  return (
    
    <div
      className={'row ' + rowClass}
      onClick={onClick}
      style={{
        gridTemplateColumns: filteredColumnWidths.join(' '), // Ustawienie szerokości kolumn
      }}
    >
      {columns.map((col, index) => {
        // Pomijanie kolumny, jeśli warunek nie jest spełniony
        if (index !== idArrayId || (idViewing && index === idArrayId)) {
          const additionalClass = Array.isArray(cellClass2ConditionList) && cellClass2ConditionList.includes(index) ? " " + cellClass2 : '';
          
          return (
            <div key={index} className={"cell " + cellClass + additionalClass}>
              {col}
            </div>
          );
        }
        return null; // Pominięcie kolumny
      })}
    </div>
  );
}

Row.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired, // Tablica tekstów dla kolumn
  columnWidths: PropTypes.arrayOf(PropTypes.string).isRequired, // Tablica szerokości kolumn
};

export default Row;